import { Filter, X } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { cn } from '../../lib/utils';

interface SpacesFiltersProps {
  filterStatus: string;
  filterWorkflow: string;
  hasActiveFilters: boolean;
  onStatusChange: (value: string) => void;
  onWorkflowChange: (value: string) => void;
  onReset: () => void;
  filteredCount: number;
  totalCount: number;
}

export function SpacesFilters({
  filterStatus,
  filterWorkflow,
  hasActiveFilters,
  onStatusChange,
  onWorkflowChange,
  onReset,
  filteredCount,
  totalCount,
}: SpacesFiltersProps) {
  return (
    <div className="flex items-center gap-3 w-full mb-8 bg-white p-4 rounded-xl shadow-[0_2px_12px_rgba(0,48,60,0.04)]">
      <div
        className="flex items-center gap-1.5 text-sm font-semibold text-muted-foreground flex-shrink-0"
        style={{ color: '#666' }}
      >
        <Filter size={18} />
        <span>Filtres :</span>
      </div>

      <div className="flex items-center gap-2 flex-1 min-w-0">
        <Select value={filterStatus} onValueChange={onStatusChange}>
          <SelectTrigger
            className={cn(
              'flex-1 min-w-[140px] max-w-[250px] transition-colors border-2 bg-[#f8fafb] h-[40px] rounded-lg text-[0.9rem] font-medium text-[#00303c]',
              filterStatus !== 'ALL' && 'border-[#00758d] bg-[#00758d]/5 text-[#00758d]',
            )}
          >
            <SelectValue placeholder="Tous les statuts" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">Tous les statuts</SelectItem>
            <SelectItem value="ACTIVE">Actifs uniquement</SelectItem>
            <SelectItem value="INACTIVE">Inactifs uniquement</SelectItem>
          </SelectContent>
        </Select>

        <Select value={filterWorkflow} onValueChange={onWorkflowChange}>
          <SelectTrigger
            className={cn(
              'flex-1 min-w-[140px] max-w-[250px] transition-colors border-2 bg-[#f8fafb] h-[40px] rounded-lg text-[0.9rem] font-medium text-[#00303c]',
              filterWorkflow !== 'ALL' && 'border-[#00758d] bg-[#00758d]/5 text-[#00758d]',
            )}
          >
            <SelectValue placeholder="Tous les workflows" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">Tous les workflows</SelectItem>
            <SelectItem value="IMMEDIATE">Réservation immédiate</SelectItem>
            <SelectItem value="QUOTE_REQUIRED">Devis requis</SelectItem>
            <SelectItem value="APPLICATION_REQUIRED">Candidature requise</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {hasActiveFilters && (
        <button
          onClick={onReset}
          className="flex-shrink-0 text-xs text-muted-foreground hover:text-foreground flex items-center gap-1 transition-colors"
          style={{ color: '#666' }}
        >
          <X className="w-3 h-3" />
          Réinitialiser
        </button>
      )}

      <div className="flex-shrink-0 whitespace-nowrap text-[0.85rem] text-[#999] ml-4">
        {hasActiveFilters
          ? `Affichage de ${filteredCount} sur ${totalCount} résultat${totalCount > 1 ? 's' : ''}`
          : `Affichage de ${totalCount} résultat${totalCount > 1 ? 's' : ''}`}
      </div>
    </div>
  );
}
